import React from 'react';
// import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuRadioSelectList } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectList';

export const SbSharedRefineMenuFilterItemTypeComponent = props => (
    <SbSharedRefineMenuRadioSelectList {...props} />
);

export const SbSharedRefineMenuFilterItemType = createFragmentContainer(
    SbSharedRefineMenuFilterItemTypeComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterItemType_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuRadioSelectList_searchBrowse
            }
        `,
    }
);
